<script setup>
import WhatsAppButton from '@/components/layout/social/WhatsAppButton.vue'
import LgViewFooter from '@/components/layout/navigation/footer/LgViewFooter.vue'
import MdViewFooter from '@/components/layout/navigation/footer/MdViewFooter.vue'
import InfoVideo from '@/components/shared/InfoVideo.vue'
import { useFooterStore } from '@/stores/config/footer'
import { useRoute } from 'vue-router'
import { ref, computed } from 'vue'

const footerStore = useFooterStore()
const infoVideoModal = ref(null)
const route = useRoute()

const dynamicFooterSections = computed(() => footerStore.dynamicFooterSections)
const socialNetworks = computed(() => footerStore.socialNetworks)
const sectionOrder = computed(() => footerStore.sectionOrder)
const copyright = computed(() => footerStore.copyright)

const openTutorialModal = () => {
  infoVideoModal.value.showModal()
}
</script>
<template>
  <div class="mt-auto">
    <InfoVideo ref="infoVideoModal" allVideos />
    <WhatsAppButton v-if="!route.path.includes('admin')" />
    <div class="footerComponent">
      <div
        class="footerComponent__main row justify-content-lg-center align-items-start justify-content-start col-12"
      >
        <!-- LgViewFooter -->
        <LgViewFooter
          :sections="dynamicFooterSections"
          :socialNetworks="socialNetworks"
          :sectionOrder="sectionOrder"
          @infoVideo="openTutorialModal"
        />
        <!-- LgViewFooter -->
        <!-- MdViewFooter -->
        <MdViewFooter
          :sections="dynamicFooterSections"
          :socialNetworks="socialNetworks"
          :sectionOrder="sectionOrder"
          @infoVideo="openTutorialModal"
        />
        <!-- MdViewFooter -->
      </div>

      <div class="footerComponent__secondary col-12 p-3">
        <div class="col">
          <h6 class="text-lg-left text-left mb-0 fw-light opacity-75">
            {{ copyright }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>
